import React, {memo} from 'react'
import FJButton from "fj-components/FJButton";
import Style from './FJPrimaryButton.module.less'
import classNames from 'classnames'

function FJPrimaryButton (props) {

  const {className, disabled} = props;
  return (
    <FJButton {...props}
              disabled={disabled}
              textClass={Style.button_text}
              className={classNames(className, Style.button, {[Style.disabled]: disabled})} />
  );
}

export default memo(FJPrimaryButton);